import { gql } from '@apollo/client'

export const PAGES = gql`
  query HelpCenterTopic_pages {
    helpCenterTopics(type: NORMAL) {
      id
      slug
    }
  }
`

export default gql`
  query HelpCenterTopic($topicSlug: String, $topicType: HelpCenterTopicType) {
    helpCenterTopics(type: NORMAL) {
      id
      title
      slug
    }

    helpCenterArticles(topicSlug: $topicSlug, topicType: $topicType, perPage: 100) {
      nodes {
        id
        slug
        body
        title
      }
    }
  }
`
